<template>
  <fragment v-if="expandedCategory === null || category.id === expandedCategory">
    <el-menu-item @click="toggleExpansion" :class="{ 'category-toggle': expanded }">
      {{ category.title }}
      <i class="el-submenu__icon-arrow el-icon-arrow-right" :class="{ rotated: expanded }"></i>
    </el-menu-item>
    <nav-categorized-products 
      :category="category" 
      :expanded="expanded" 
      :indexPrefix="indexPrefix" 
      :key="expanded ? 'expanded-' + category.id : 'collapsed-' + category.id" 
    />
  </fragment>
</template>

<script>
import mixins from '@/mixins';
import NavCategorizedProducts from './NavCategorizedProducts.vue';
import { Fragment } from 'vue-frag';

export default {
  name: 'NavDesktopProductsSubmenu',
  mixins: [
    mixins.supportedFeatures
  ],
  props: {
    indexPrefix: {
      type: String,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
    expandedCategory: {
      type: String,
      required: false,
      default: null,
    }
  },
  computed: {
    expanded() {
      return this.expandedCategory === this.category.id;
    }
  },
  methods: {
    toggleExpansion() {
      this.$emit('expansionChanged', this.expanded ? null : this.category);
    }
  },
  components: {
    Fragment,
    NavCategorizedProducts,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';

.el-menu-item {
  &.category-toggle {
    &.is-active {
      color: $--color-primary;

      &:hover,
      &:active {
        color: $--color-primary-dark;
      }
    }

    &:deep(.rotated) {
      transform: rotateZ(90deg);
    }
  }
}
</style>
